module.exports = __webpack_public_path__ + "img/bg-login.761e3c61.jpg";